window.UFT = window.UFT || {};
window.UFT.EventManager =
	window.UFT.EventManager ||
	(function () {
		class EventManager {
			constructor() {
				this.events = {};
				this.debug = false;
				this.eventStrings = {
					CART_ITEM_ADDED: 'cart:item-added',
					FACETS_UPDATE_IN_PROGRESS: 'facets:update-in-progress',
					FACETS_FINISH_UPDATE: 'facets:finish-update',
					PRODUCT_HTML_UPDATED: 'product:html-updated',
					PRODUCT_SELLING_PLAN_CHANGE: 'product:selling-plan-change',
					PRODUCT_VARIANT_CHANGE: 'product:variant-change',
					PRODUCT_VIEWED: 'product:viewed',
					SEARCH_RESULTS_META: 'search:results:meta',
					SEARCH_UPDATE_IN_PROGRESS: 'search:update-in-progress',
					SEARCH_FINISH_UPDATE: 'search:finish-update',
				};
			}

			/**
			 * @param {string} eventName
			 * @param {Function} callback
			 * @returns {Function} Returns unsubscribe method
			 */
			on(eventName, callback) {
				if (typeof callback !== 'function') {
					console.error(`[EventManager] The callback for event "${eventName}" is not a function.`);
					return () => {}; // Return a no-op function for safety
				}

				if (!this.events[eventName]) {
					this.events[eventName] = [];
				}
				this.events[eventName].push(callback);

				// Return an unsubscribe function for easy cleanup.
				return () => this.off(eventName, callback);
			}

			/**
			 * @param {string} eventName
			 * @param {Function} callback
			 */
			off(eventName, callback) {
				if (!this.events[eventName]) {
					return;
				}
				this.events[eventName] = this.events[eventName].filter((eventCallback) => eventCallback !== callback);
			}

			/**
			 * @param {string} eventName
			 * @param {*} [data]
			 */
			dispatch(eventName, data) {
				if (this.debug) {
					console.log(`[EventManager] Event dispatched: "${eventName}"`, data);
				}

				if (!this.events[eventName]) {
					return;
				}

				// Iterate over a copy of the array to prevent issues if a subscriber unsubscribes during the loop.
				[...this.events[eventName]].forEach((callback) => {
					try {
						callback(data);
					} catch (error) {
						console.error(`[EventManager] Error in subscriber for event "${eventName}":`, error);
					}
				});
			}
		}
		return new EventManager();
	})();
